import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import React, {useMemo, useState} from 'react'
import {notifyOnError} from 'views/AppLocals/factory/createErrorEvent'
import {NullAsDefault} from 'views/Shared'
import {getId, getType} from "../../../../apis/model/base";
import {showDeleteConfirmDialog} from "../../factory/createConfirmDialog";
import {Modal} from "antd";
import {withProps} from "recompose";
import LoadingBlock from "../../../Loading/LoadingBlock";
import _ from "lodash";
import {shop_getById_Api} from "../../../../apis";
import useProductActions from "./useProductActions";
import CRUD from "../../../Shared/enums/CRUD";
import {ProductFormCreate, ProductFormEdit} from "../components/ProductForm";
import {FetchProductById} from "../containers/FetchEntity";

export const useProductForm = ({
                                   shop,
                                   autoRefresh = true,
                               }) => {
    const t = useTranslate()
    const [refreshKey, setRefreshKey] = useState()
    const [localShop, setLocalShop] = useState(shop)
    const onError = notifyOnError(t)
    const onRefresh = () => {
        if (autoRefresh) {
            setRefreshKey(Date.now())
        }
    }
    const owner_type = getType(shop);
    const owner_id = getId(shop);

    const {handleAsyncAction: getShopById} = useAsyncAction({
        apiInfo: shop_getById_Api,
        onSuccess: (result, data) => {
            const dataItem = _.get(data, 'response.data');
            setLocalShop(dataItem);
        },
    })

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const onCancel = () => {
        setAction({})
    }

    const fetchShopOnSuccess = () => {
        onCancel()
        getShopById({}, {id: shop?.id})
    }

    const {
        createNewProduct,
        editProductInfo,
        deleteProduct,
        publishProduct,
    } = useProductActions({
        notifyListeners: {
            onCancel: onCancel,
            onRefresh: fetchShopOnSuccess,
        }
    })

    const confirmDelete = (id) => {
        if (id) {
            showDeleteConfirmDialog({
                translate: t,
                title: 'delete product',
                message: 'are you sure you want to delete this product of shop',
                onOk: () => {
                    deleteProduct({}, {id})
                },
            })
        }
    }

    const handleAction = (action, params) => {
        const id = getId(params)
        switch (action) {
            case CRUD.CREATE:
            case CRUD.UPDATE:
                setAction({type: action, value: params})
                break
            case CRUD.DELETE:
                confirmDelete(id)
                break
            default:
                break
        }
    }

    const modal = useMemo(() => {
        if (!!!action?.type) return null;
        let params = {}
        let modal_params = {}
        let Component = NullAsDefault
        let Wrapper = ({children}) => children({item: {}})
        const id = getId(action?.value)
        switch (action?.type) {
            case CRUD.CREATE:
                Component = ProductFormCreate
                modal_params = {
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('create product')}
                        </div>
                    ),
                }
                params = {
                    owner_type,
                    owner_id,
                    shop,
                    onSubmit: (values) => {
                        createNewProduct(values, {id: shop?.id})
                    },
                }
                break
            case CRUD.UPDATE:
                Wrapper = withProps({id})(FetchProductById)
                Component = ProductFormEdit
                modal_params = {
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('edit product')}
                        </div>
                    ),
                }
                params = {
                    owner_type,
                    owner_id,
                    shop,
                    onSubmit: (values) => {
                        editProductInfo(values, {id})
                    },
                }
                break

            default:
                break
        }
        return (
            <Modal
                width={720}
                footer={null}
                onCancel={onCancel}
                open={action?.type}
                destroyOnHidden={true}
                className="custom-modal"
                {...modal_params}>
                <Wrapper>
                    {({item, isLoading}) => {
                        if (!!isLoading) {
                            return <LoadingBlock/>
                        }
                        return (
                            <Component
                                {...params}
                                {...{item, onCancel}}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
    }, [action, shop?.id])

    return {
        modal,
        onCancel,
        handleAction,

        confirmDelete,
        refreshKey,

        createNewProduct,
        editProductInfo,
        deleteProduct,
        publishProduct,
    }
}
